<template>
  <card-shell
    :elevation="flat ? 0 : (clickable && !race.decided) ? 2 : 0"
    :flat="flat"
    :inactive="race.decided"
    :clickable="clickable"
    @click="$emit('click', $event)"
  >
    <template #title>
      <div class="d-flex justify-space-between align-start">
        <div>
          <div v-if="race.location?.name">{{ race.location.name }}<span v-if="race.tableNumber"> · Table {{ race.tableNumber }}</span></div>
          <div v-if="scheduledTimeLabel" class="text-disabled">{{ scheduledTimeLabel }}</div>
        </div>
        <v-chip v-if="race.isBracketRace" color="primary">{{ bracketLabel }}</v-chip>
      </div>
    </template>
    <versus-row :teams="teams" style="margin-top: 28px;" />
    <ScoreDisplay :left="race.homeGoals" :right="race.awayGoals" :dash="noScoredGames" :score-shadow="scoreShadow" />
    <template v-if="race.decided" #footer>
      <div class="d-flex align-center justify-center" style="gap: 4px;">
        <v-icon icon="mdi-trophy-outline" size="small" color="primary" />
        <span class="text-body-2 font-weight-medium">Winner: {{ winnerLabel }}</span>
      </div>
    </template>
  </card-shell>
</template>

<script>
import CardShell from "@/components/card-shell.vue";
import VersusRow from "@/components/versus-row.vue";
import ScoreDisplay from "@/components/score-display.vue";
import { bracketSlotName } from "@/utils/league-bracket";

export default {
  name: "RaceCard",
  components: {
    CardShell,
    VersusRow,
    ScoreDisplay
  },
  props: {
    race: {
      type: Object,
      required: true
    },
    clickable: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    scoreShadow: {
      type: String,
      default: "fade"
    }
  },
  emits: ["click"],
  computed: {
    teams () {
      return [
        [{ id: this.race.homeSquad?.id || "home", name: this.race.homeSquad?.title }],
        [{ id: this.race.awaySquad?.id || "away", name: this.race.awaySquad?.title }]
      ];
    },
    noScoredGames () {
      return !this.race.inactiveGames || this.race.inactiveGames.length === 0;
    },
    winnerLabel () {
      return this.race?.winningSquadTitle || "";
    },
    scheduledTimeLabel () {
      const date = this.race.date;
      if (!date) return "";
      const d = date.toDate ? date.toDate() : new Date(date);
      const dateLabel = d.toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
      const timeLabel = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
      return `${dateLabel} · ${timeLabel}`;
    },
    bracketLabel () {
      return bracketSlotName(this.race.bracketSlot, this.race.league.bracketRoundCount);
    }
  }
};
</script>
